import React, { useState, useEffect } from "react";
import { FaCartPlus, FaShoppingBag, FaChevronLeft, FaChevronRight, FaSearch } from "react-icons/fa";
import { BASE_URL } from "../backend/backend.js"; // Imported backend URL

const API_BASE_URL = `${BASE_URL}/api`; // Replaced hardcoded IP
const CART_API_URL = `${BASE_URL}/user/saveProductInCart`; // Replaced hardcoded IP

const MedicineSellingPage = () => {
  const [medicines, setMedicines] = useState([]);
  const [index, setIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [cartMessage, setCartMessage] = useState(null);

  useEffect(() => {
  fetch(`${API_BASE_URL}/getAllMedicine`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Failed to fetch medicines");
      }

      return res.json();
    })

    .then((data) => {
      console.log("Medicine API Response:", data);

      if (data?.content) {
        const formattedMedicines = data.content.map((med) => ({
          id: med.id,

          name: med.medicineName,

          detail:
            med.description ||
            med.shortComposition1 ||
            "No detail available.",

          image:
            med.image ||
            "https://via.placeholder.com/70",

          normalPrice:
            parseFloat(med.price || 0) * 1.2,

          discountedPrice:
            parseFloat(
              med.descountPrice || med.price || 0
            ),

          totalPiece:
            parseFloat(med.totalPiece || 0),
        }));

        setMedicines(formattedMedicines);
      }
    })

    .catch((err) => {
      console.error("Error fetching medicines:", err);
    });
}, []);
  const displayedMedicines = medicines.length > 0 ? [...medicines, ...medicines] : []; // Duplicate for continuous scrolling

  const slideRight = () => {
    if (!isHovered && displayedMedicines.length > 0) {
      setIndex((prevIndex) => (prevIndex + 1) % displayedMedicines.length);
    }
  };

  const slideLeft = () => {
    if (!isHovered && displayedMedicines.length > 0) {
      setIndex((prevIndex) => (prevIndex - 1 + displayedMedicines.length) % displayedMedicines.length);
    }
  };

  const handleAddToCart = (medicineId, medicineName) => {
    const selectedMedicine = medicines.find((med) => med.id === medicineId);
    if (selectedMedicine && selectedMedicine.totalPiece > 0) {
      fetch(`${CART_API_URL}?id=${medicineId}&quantity=1`, { // Assuming quantity is 1 for this button
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.body) {
            setCartMessage({ text: `${medicineName} added to cart!`, medicineId });
            setTimeout(() => setCartMessage(null), 3000);
          } else {
            setCartMessage({ text: `Failed to add ${medicineName} to cart.`, medicineId });
            setTimeout(() => setCartMessage(null), 3000);
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          setCartMessage({ text: `Failed to add ${medicineName} to cart.`, medicineId });
          setTimeout(() => setCartMessage(null), 3000);
        });
    } else if (selectedMedicine) {
      setCartMessage({ text: `${medicineName} is not available.`, medicineId });
      setTimeout(() => setCartMessage(null), 3000);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      slideRight();
    }, 3000);
    return () => clearInterval(interval);
  }, [displayedMedicines, isHovered]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        padding: "10px",
        borderRadius: "25px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        width: "300px",
        margin: "0 auto 20px auto",
        position: "relative",
      }}>
        <FaSearch style={{ position: "absolute", left: "10px", color: "#555" }} />
        <input
          type="text"
          placeholder="Search medicines..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "8px 30px",
            border: "none",
            outline: "none",
            borderRadius: "25px",
            fontSize: "16px",
          }}
        />
      </div>
      <div style={{ position: "relative", overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <button
          onClick={slideLeft}
          style={{ position: "absolute", left: "10px", background: "transparent", color: "#000", border: "none", borderRadius: "50%", padding: "10px", cursor: "pointer", zIndex: 10 }}>
          <FaChevronLeft size={20} />
        </button>
        <div style={{ display: "flex", transition: "transform 0.5s ease-in-out", transform: `translateX(-${index * 230}px)`, gap: "10px" }}>
          {displayedMedicines.map((medicine, i) => (
            <div key={medicine.id || i}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "10px",
                textAlign: "center",
                backgroundColor: "#fff",
                minWidth: "220px",
                position: "relative", // For absolute positioning of message
              }}>
              <img src={medicine.image} alt={medicine.name} style={{ width: "70px", height: "70px", marginBottom: "10px" }} />
              <h3 style={{ margin: "5px 0", fontSize: "14px" }}>{medicine.name}</h3>
              <p style={{ fontSize: "12px", color: "#555" }}>{medicine.detail}</p>
              {medicine.totalPiece === 0 ? (
                <p style={{ color: "red", fontWeight: "bold" }}>Not Available</p>
              ) : (
                <>
                  <p style={{ textDecoration: "line-through", color: "red", fontSize: "12px" }}>₹{medicine.normalPrice?.toFixed(2)}</p>
                  <p style={{ fontSize: "16px", fontWeight: "bold" }}>₹{medicine.discountedPrice?.toFixed(2)} <span style={{ color: "green" }}>({(((medicine.normalPrice - medicine.discountedPrice) / medicine.normalPrice) * 100)?.toFixed(0)}% OFF)</span></p>
                </>
              )}
              <div style={{ display: "flex", justifyContent: "center", gap: "5px", marginTop: "5px" }}>
                {medicine.totalPiece > 0 ? (
                  <>
                    <button
                      onClick={() => handleAddToCart(medicine.id, medicine.name)}
                      style={{ background: "#28a745", color: "#fff", border: "none", borderRadius: "5px", padding: "6px 10px", fontSize: "12px", cursor: "pointer" }}>
                      <FaCartPlus /> Add
                    </button>
                    <button style={{ background: "#007bff", color: "#fff", border: "none", borderRadius: "5px", padding: "6px 10px", fontSize: "12px", cursor: "pointer" }}>
                      <FaShoppingBag /> Buy
                    </button>
                  </>
                ) : (
                  <p style={{ color: "red", fontWeight: "bold", marginTop: "5px" }}>Not Available</p>
                )}
              </div>
              {cartMessage?.medicineId === medicine.id && (
                <div style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: cartMessage.text.includes("Failed") ? "rgba(220, 53, 69, 0.8)" : "rgba(0, 123, 255, 0.8)",
                  color: "white",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "bold",
                  zIndex: 1,
                }}>
                  {cartMessage.text}
                </div>
              )}
            </div>
          ))}
        </div>
        <button
          onClick={slideRight}
          style={{ position: "absolute", right: "10px", background: "transparent", color: "#000", border: "none", borderRadius: "50%", padding: "10px", cursor: "pointer", zIndex: 10 }}>
          <FaChevronRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default MedicineSellingPage;